import React, { useEffect, useRef, useState } from 'react'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { MdOutlineChangeCircle } from 'react-icons/md';
import { parseFullAddress } from '../../redux/actions/upload';
import { getParsedAddress } from '../../services/helper';
import { useDispatch } from 'react-redux';
import AllContacts from '../ContactsComponent/allContacts';
import { getExistingContacts } from '../../redux/actions/contact';
import { toast } from '../CommonComponents/ToastComponent/toast';
import ModalComponent from '../CommonComponents/Modal';
import CreateContact from '../ContactsComponent/createContact';
import ContactView from '../ContactsComponent/contactView';

const CreateChildBasicTab = ({ basicInfo, columns, onChangeBasicInfo, isPhoneValid, isValidatingPhone, handleBasicInfoPhoneNumberFocusOut, handleBasicInfoEmailFocusOut, isEmailValid, isValidatingEmail, countryCode, setAllContacts, allContacts }) => {
    const dispatch = useDispatch()
    const [isParsingAddress, setIsParsingAddress] = useState(false)
    const [showAllContacts, setShowAllContacts] = useState({
        email: false,
        phone: false
    })
    const [existedContacts, setExistedContacts] = useState([])
    const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
    const [currentContact, setCurrentContact] = useState({})
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})

    useEffect(() => {
        if (allContacts && allContacts?.length > 0) {
            setExistedContacts(allContacts)
        } else {
            setExistedContacts([])
        }
    }, [allContacts])

    const handleChange = (columnName,newValue, isValid) => {
        if (columnName === 'phone') {
            onChangeBasicInfo(columnName, newValue, isValid)
        } else {
            onChangeBasicInfo(columnName, newValue, isValid)
        }
    }

    let supplierColumns = [...columns]
    supplierColumns.splice(1, 0, {
        name: 'companyId',
        label: 'Company ID',
    });
    const phoneInputRefname = useRef(null);

    const handlePhoneNumberFocusOut = async (event, country, phoneValue) => {
        handleBasicInfoPhoneNumberFocusOut(event, country, phoneValue)
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleEmailFocusOut = async (emailValue, isRetry = false) => {
        handleBasicInfoEmailFocusOut(emailValue, isRetry)
    }

    const parseAddress = async () => {
        if (basicInfo?.address1?.value) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(basicInfo?.address1?.value))
                setIsParsingAddress(false)
                const parsedResult = getParsedAddress(addressResult)
                onChangeBasicInfo('parseAddress', parsedResult)
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    const onContactMouseHover = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (event.target?.dataset?.contactId) {
            const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
            setCurrentContact(contact ? contact : {})
        } else {
            setCurrentContact({})
        }
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'block'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'block'
        }
    }

    const onContactMouseHoverOut = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'none'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'none'
        }
        setCurrentContact({})
    }

    const onPhoneEmailClick = (type1, type2) => {
        setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false })
        setExistedContacts(allContacts)
    }

    const onPhoneEmailFocusOutClick = () => {
        setShowAllContacts({ ...showAllContacts, email: false, phone: false })
        setExistedContacts(allContacts)
    }

    useEffect(() => {
        if (showAllContacts?.phone && basicInfo?.phone?.value?.trim() && basicInfo?.phone?.value?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.phone?.value?.trim(), 'phone')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [basicInfo?.phone?.value])

    useEffect(() => {
        if (showAllContacts?.email && basicInfo?.email?.value?.trim() && basicInfo?.email?.value?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.email?.value?.trim(), 'email')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [basicInfo?.email?.value])

    const onGetExistingContacts = (searchValue, type = '') => {
        try {
            setIsLoadingExistingContacts(true)
            dispatch(getExistingContacts({ searchValue, type })).then((res) => {
                if (res?.contacts && res?.contacts?.length > 0) {
                    setExistedContacts(res?.contacts)
                } else {
                    setExistedContacts([])
                }
                setIsLoadingExistingContacts(false)
            }).catch(() => {
                setExistedContacts([])
                setIsLoadingExistingContacts(false)
            })
        } catch (err) {
            setExistedContacts([])
            setIsLoadingExistingContacts(false)
        }
    }

    const handleContactClick = async (rowData) => {
        var colName = ''
        var value = {
            target: {}
        }
        if (showAllContacts?.phone) {
            if (!rowData?.phone) {
                toast.show({
                    title: 'Warning',
                    description: 'No phone number is assigned to this contact!'
                })
                return
            }
            colName = 'phone'
            value.target.value = rowData?.phone || ''
            value.target.phoneContactId = rowData?.id || null
            // tmpData.phoneContactId = rowData?.id || null
            handlePhoneNumberFocusOut(null, null, value.target.value)
        }
        if (showAllContacts?.email) {
            if (!rowData?.email) {
                toast.show({
                    title: 'Warning',
                    description: 'No email is assigned to this contact!'
                })
                return
            }
            colName = 'email'
            value.target.value = rowData?.email || ''
            value.target.emailContactId = rowData?.id || null
            // tmpData.emailContactId = rowData?.id || null
            handleEmailFocusOut(value.target.value)
        }
        if (rowData) {
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
            if (index === -1) {
                tmpContacts.push(rowData)
            }
            setAllContacts(tmpContacts)
        }
        handleChange(colName, value)
        onPhoneEmailFocusOutClick()
        // setSupplierInfo(tmpData)
    }

    const onCreateContact = () => {
        let value = ''
        let colName = ''
        if (showAllContacts?.phone) {
            colName = 'phone'
            value = basicInfo?.phone?.value ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(basicInfo?.phone?.value) ? `1 ${basicInfo?.phone?.value}` : basicInfo?.phone?.value) : ''
        } else {
            colName = 'email'
            value = basicInfo?.email?.value || ''
        }
        setShowAddNewContact(true)
        setContactDataFromField({
            colName,
            value
        })
        onPhoneEmailFocusOutClick()
    }

    const handleCreateContactClose = async (e, isGetContactsData = false, contact = null) => {
        const contactId = contact?.id || null
        if (contactId) {
            contact.contactName = contact?.firstname + ' ' + contact?.lastname
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            tmpContacts.push(contact)
            if (contactDataFromField?.colName === 'email') {
                var value = {
                    target: {}
                }
                value.target.value = contact?.email || ''
                value.target.emailContactId = contactId
                handleChange('email', value, true)
                // setBasicInfo({ ...basicInfo, emailContactId: contactId, email: contact?.email })
                await handleEmailFocusOut(contact?.email)
            } else {
                var value = {
                    target: {}
                }
                value.target.value = contact?.phone || ''
                value.target.phoneContactId = contactId
                handleChange('phone', value, true)
                // setBasicInfo({ ...basicInfo, phoneContactId: contactId, phone: contact?.phone })
                await handlePhoneNumberFocusOut(null, null, contact?.phone)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }

        setContactDataFromField({})
        setShowAddNewContact(false)
    }

    const onGetContactsData = () => {
        if (showAllContacts?.email) {
            onGetExistingContacts(basicInfo?.email?.value?.trim(), 'email')
        }
        if (showAllContacts?.phone) {
            onGetExistingContacts(basicInfo?.phone?.value?.trim(), 'phone')
        }
    }

    const handleRemoveContact = (colName) => {
        var value = {
            target: {}
        }
        if (colName === 'email') {
            value.target.value = ''
            value.target.emailContactId = null
        } else {
            value.target.value = ''
            value.target.phoneContactId = null
        }
        handleChange(colName, value)
    }

    return (
        <div className="basic-tab">
            <div className="main-info">
                {
                    supplierColumns && supplierColumns.length > 0 && supplierColumns.map((col, index) => {
                        if (col.name === 'url' || col.name === 'naics' || col.name === 'sic' || col.name === 'abbreviatedState') {
                            return
                        }
                        return (<div key={col.name} className='main-info-child flex'>
                            <h4 className='first-child fw-bold text-black mb-0 flex-40'>{col.label}:</h4>
                            {col.name === 'phone' ?
                                <>
                                    <div className="phone-input-parent flex align-center position-relative">
                                        <div className={`d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row${basicInfo?.phoneContactId?.value ? ' input-group h-100' : ''}`}>
                                            {basicInfo?.phoneContactId?.value && (
                                                <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('phone') }}>X</span>
                                            )}
                                            <input
                                                value={basicInfo[col.name]?.value || ''}
                                                className={`search-input basicvalue border-0 h4 mb-0 ms-0 text-primary`}
                                                onChange={e => handleChange(col.name, e)}
                                                autoComplete='no-phone'
                                                onClick={() => { onPhoneEmailClick('phone', 'email') }}
                                                onMouseOver={(e) => { onContactMouseHover(e) }}
                                                onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                data-contact-id={basicInfo?.phoneContactId?.value || ''}
                                            // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                            />
                                            {/* <ReactPhoneInput
                                                className='phone-input-parent'
                                                country={'us'}
                                                value={basicInfo?.[col.name]?.value || ''}
                                                onChange={(value, country, e, formattedValue) => { handleChange(col.name, formattedValue, country, e) }}
                                                onBlur={(event, country) => { handlePhoneNumberFocusOut(event, country, basicInfo[col.name]?.value) }}
                                                countryCodeEditable={false}
                                                preferredCountries={['us']}
                                                onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                                ref={phoneInputRefname}
                                                buttonClass='border-0 border-end border-dark'
                                                inputProps={{
                                                    className: 'form-control border-0'
                                                }}
                                            /> */}
                                            {basicInfo?.[col.name]?.value && !showAllContacts?.phone && (
                                                <ContactView contact={currentContact} />
                                            )}
                                            {showAllContacts?.phone && (
                                                <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                            )}
                                            <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                <input
                                                    type="text"
                                                    className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark"
                                                    placeholder="phone extension"
                                                    onChange={(newValue) => handleChange('phoneExtension', newValue)}
                                                    value={basicInfo?.['phoneExtension']?.value || ''}
                                                    disabled={(!basicInfo['phone']?.value || !isPhoneValid || basicInfo['phone']?.value === countryCode) ? true : false}
                                                />
                                            </div>
                                        </div>
                                        {isValidatingPhone && (<Loader />)}
                                        {!isValidatingPhone && isPhoneValid !== '' &&
                                            (isPhoneValid ?
                                                <BsCheckSquare color="#067911" size={26} />
                                                :
                                                <BsXSquare color="#f75a52" size={26} />
                                            )
                                        }
                                    </div>
                                </>
                                :
                                col.name === 'email' ?
                                    <>
                                        <div className={`phone-input-parent flex align-center position-relative${basicInfo?.emailContactId?.value ? ' input-group h-100 align-items-center' : ''}`}>
                                            {basicInfo?.emailContactId?.value && (
                                                <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('email') }}>X</span>
                                            )}
                                            <input
                                                type="text"
                                                style={{ marginLeft: basicInfo?.emailContactId?.value ? '-10px' : '0' }}
                                                className="search-input h4 mb-0 text-primary border border-primary"
                                                onChange={(newValue) => handleChange(col.name, newValue)}
                                                value={basicInfo[col.name]?.value || ''}
                                                onClick={() => { onPhoneEmailClick('email', 'phone') }}
                                                onMouseOver={(e) => { onContactMouseHover(e) }}
                                                onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                // onBlur={() => { handleEmailFocusOut(basicInfo[col.name]?.value) }}
                                                autoComplete='no-email'
                                                data-contact-id={basicInfo?.emailContactId?.value || ''}
                                            />
                                            {basicInfo[col.name]?.value && !showAllContacts?.email && (
                                                <ContactView contact={currentContact} />
                                            )}
                                            {showAllContacts?.email && (
                                                <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                            )}
                                            {isValidatingEmail && (<Loader />)}
                                            {basicInfo[col.name]?.value && !isValidatingEmail && isEmailValid !== '' &&
                                                (isEmailValid ?
                                                    <BsCheckSquare color="#067911" size={26} />
                                                    :
                                                    <>
                                                        <BsXSquare color="#f75a52" size={26} />
                                                        <MdOutlineChangeCircle
                                                            title='Retry'
                                                            role='button'
                                                            color="#14438b"
                                                            size={30}
                                                            onClick={() => { handleEmailFocusOut(basicInfo[col.name]?.value, true) }}
                                                        />
                                                    </>
                                                )
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className={`w-100 ${col.name === 'address1' ? 'd-flex gap-3 h-100' : ''}`}>
                                        <input
                                            type="text"
                                            className="search-input h4 mb-0"
                                            onChange={(newValue) => handleChange(col.name, newValue)}
                                            value={basicInfo[col.name]?.value || ''} />
                                        {col.name === 'address1' && basicInfo?.address1?.value && (
                                            <div className="position-relative text-center h-100">
                                                {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                                                <button
                                                    type="button"
                                                    className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 bg-dark-blue rounded text-white`}
                                                    onClick={parseAddress}
                                                >
                                                    Parse Address
                                                </button>
                                            </div>
                                        )}
                                    </div>
                            }
                        </div>)
                    })
                }
            </div>
            <div className="other">
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0 flex-40'>URL:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            onChange={(newValue) => handleChange('url', newValue)}
                            value={basicInfo['url']?.value} />
                    </div>
                </div>
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0 flex-40'>NAICS Code:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            onChange={(newValue) => handleChange('naics', newValue)}
                            value={basicInfo['naics']?.value} />
                    </div>
                </div>
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0 flex-40'>SIC Code:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            onChange={(newValue) => handleChange('sic', newValue)}
                            value={basicInfo['sic']?.value} />
                    </div>
                </div>
            </div>
            {showAddNewContact && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact onClose={handleCreateContactClose} contactDataFromField={contactDataFromField} />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default CreateChildBasicTab